import { AxiosResponse } from "axios";
import { apiQueryAdapter } from "../apiQueryAdapter";
import { DoorStatus, DoorType } from "./enums";
import {
  Door,
  LoadboardListManifestTrip,
  LoadboardListManifestRequestParams,
  LoadBoardDispatchLoadRequest,
} from "./models";

export interface AssignDoorRequest {
  terminalNumber: number;
  doorNumber: string;
  driverId?: number | string | null;
  driverName?: string;
  primaryDistributor: number;
  secondaryDistributors: number[];
  trailerNumber: number;
  manifest: number;
  carrierNumber: number;
  priority: number;
  doorStatus: DoorStatus | null;
  doorUsage: string;
  doorType: DoorType;
  tripNumber: string;
  cutDate: string;
  carrierChangeReasonCode?: string;
  carrierChangeReasonDescription?: string;
}


class LoadBoardService {
  private static instance: LoadBoardService;
  private constructor() { }

  static getInstance(): LoadBoardService {
    if (!LoadBoardService.instance) {
      LoadBoardService.instance = new LoadBoardService();
    }
    return LoadBoardService.instance;
  }

  public getDoors = async (terminalNumber: number): Promise<AxiosResponse<Door[]>> => {
    return await apiQueryAdapter.query(`/load-board/terminals/${terminalNumber}/doors`, "GET");
  };

  public assignDoor = async (request: AssignDoorRequest): Promise<AxiosResponse<void>> => {
    return await apiQueryAdapter.query(`/load-board/doors/assign`, "PUT", { body: request });
  };

  public getManifestTrips = async (
    params: LoadboardListManifestRequestParams
  ): Promise<AxiosResponse<LoadboardListManifestTrip[]>> => {

    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        searchParams.append(key, value.toString());
      }
    });

    const queryString = searchParams.toString();
    const url = queryString
      ? `/load-board/manifests/trips?${queryString}`
      : `/load-board/manifests/trips`;

    return await apiQueryAdapter.query(url, "GET");
  };

  public closeDoor = async (
    doorNumber: string | number,
    terminalNumber: number,
    request: { trailerNumber?: number; manifestNumber?: number; carrierNumber?: number, sealNumber?: string }
  ): Promise<AxiosResponse<void>> => {
    return await apiQueryAdapter.query(
      `/load-board/doors/${doorNumber}/close?terminalNumber=${terminalNumber}`,
      "POST",
      { body: request }
    );
  };

  public dispatchLoad = async (
    manifestNumber: number,
    terminalNumber: number,
    request: LoadBoardDispatchLoadRequest
  ): Promise<AxiosResponse<void>> => {
    return await apiQueryAdapter.query(
      `/load-board/manifests/${manifestNumber}/dispatch?terminalNumber=${terminalNumber}`,
      "POST",
      { body: request }
    );
  };

  /**
   * Optional later: server CSV export (same filters as list).
   * FE currently builds CSV client-side from visible grid rows.
   * GET /load-board/manifests/trips/download/csv
   */
  // public exportManifestTripsCsv = async (
  //   params: LoadboardListManifestRequestParams
  // ): Promise<Blob> => {
  //   const searchParams = new URLSearchParams();
  //   Object.entries(params).forEach(([key, value]) => {
  //     if (value !== undefined && value !== null && value !== "") {
  //       if (Array.isArray(value)) {
  //         value.forEach((v) => {
  //           if (v !== undefined && v !== null && v !== "") {
  //             searchParams.append(key, String(v));
  //           }
  //         });
  //         return;
  //       }
  //       searchParams.append(key, String(value));
  //     }
  //   });
  //   const queryString = searchParams.toString();
  //   const url = queryString
  //     ? `/load-board/manifests/trips/download/csv?${queryString}`
  //     : `/load-board/manifests/trips/download/csv`;
  //   const response = await apiQueryAdapter.query<Blob>(url, "GETDOC", {
  //     responseType: "blob",
  //   });
  //   return response.data;
  // };
}

export default LoadBoardService;